export default __webpack_public_path__ + "static/b65f2bfbf87092a3fa2cb1d80912f2c6.png";